import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "User Info", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_EssentialLink = _resolveComponent("EssentialLink")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    modelValue: _ctx.isLeftDrawerOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLeftDrawerOpen) = $event)),
    bordered: "",
    overlay: "",
    "content-class": "bg-grey-1"
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" todo: fix mode-value  "),
      _createVNode(_component_q_scroll_area, { class: "fit" }, {
        default: _withCtx(() => [
          (_ctx.isLogged)
            ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, {
                    header: "",
                    class: "text-grey-8"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "mdi-account"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user.email), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user.groups.join(',\n')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_EssentialLink, {
                    title: "Logout",
                    link: "/auth/logout"
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (!_ctx.isLogged)
            ? (_openBlock(), _createBlock(_component_q_list, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_EssentialLink, {
                    title: "Login",
                    link: "/auth/login"
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}